import { render, staticRenderFns } from "./FSwitchField.vue?vue&type=template&id=7f37c9ca&"
import script from "./FSwitchField.vue?vue&type=script&lang=js&"
export * from "./FSwitchField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports